"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkageResult = exports.Linkage = void 0;

var _ = require(".");

// Copyright 2017-2019 @polkadot/types authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
class Linkage extends _.Struct {
  constructor(Type, value) {
    super({
      previous: _.Option.with(Type),
      next: _.Option.with(Type)
    }, value);
  }

  static withKey(Type) {
    return class extends Linkage {
      constructor(value) {
        super(Type, value);
      }

    };
  }

  get previous() {
    return this.get('previous');
  }

  get next() {
    return this.get('next');
  }

}

exports.Linkage = Linkage;

class LinkageResult extends _.Tuple {
  constructor(_ref, _ref2) {
    let [TypeKey, keys] = _ref;
    let [TypeValue, values] = _ref2;
    super({
      Keys: _.Vector.with(TypeKey),
      Values: _.Vector.with(TypeValue)
    }, [keys, values]);
  }

}

exports.LinkageResult = LinkageResult;